export default __webpack_public_path__ + "static/media/Head_3_Ear_3_C1.1047899c.svg";